/**
 * AddOnTool Store
 *
 * Manages Home Screen add-on tools and related lookups.
 */

import _ from 'lodash';
import { SeeqNames } from '@/main/app.constants.seeqnames';
import { type GetStoreState, type SetStoreState, createStore } from '@/stores/createStore';
import type { AddOnToolOutputV1 } from '@/sdk/model/AddOnToolOutputV1';

export interface AddOnToolState {
  addOnTools: AddOnToolOutputV1[];
}

const initialState: AddOnToolState = {
  addOnTools: [],
};

const addOnToolActionsFactory = (set: SetStoreState<AddOnToolState>, _get: GetStoreState<AddOnToolState>) => ({
  /**
   * Set Home Screen add-on tools (filters to Homescreen launch location)
   */
  setHomeScreenAddOnTools: (addOnTools: AddOnToolOutputV1[] = []) => {
    const homescreenAddOnTools = _.filter(
      addOnTools,
      (addOnTool) => addOnTool.launchLocation === SeeqNames.API.AddOnToolLaunchLocation.Homescreen,
    );

    set((draft: AddOnToolState) => {
      draft.addOnTools = homescreenAddOnTools;
    });
  },
});

const [AddOnToolStoreProvider, useStore, useSelector] = createStore('AddOnTool', initialState, addOnToolActionsFactory);

export { AddOnToolStoreProvider };

/**
 * Get add-on tool store's actions
 */
export const useAddOnToolActions = () => useStore().actions;

/**
 * Get Home Screen add-on tools
 */
export const useHomeScreenAddOnTools = () => useSelector((state) => state.addOnTools);
